export default __webpack_public_path__ + "static/v2_lia_bw-0eb96a0de6e3e888eba1983c4fa6ebee.jpg";